import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const OekonomiskRaadgivning = () => {
  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Privatøkonomi: Økonomisk rådgivning for private</title>
        <meta name="description" content="Økonomisk rådgivning for private: Vi tilbyder et økonomisk rådgivningsforløb med en uforpligtende telefonsamtale eller et formøde. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Privatøkonomisk rådgivning</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Privatøkonomisk rådgivning</h1>

        <div className="flex flex-col md:flex-row gap-10 mb-12">
          <div className="md:w-1/3">
            <img 
              src="https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/70fb4444-96ad-4033-91e8-0f60c837c736.jpg" 
              alt="økonomisk rådgivning" 
              className="rounded-2xl shadow-lg w-full"
            />
          </div>
          <div className="md:w-2/3 prose prose-slate prose-lg">
            <p className="leading-relaxed">
              Et økonomisk rådgivningsforløb starter med en uforpligtende telefonsamtale eller et formøde, hvor formålet er at afdække dit rådgivningsbehov.
            </p>
            <p className="leading-relaxed">
              Du vil herefter blive tilbudt den rådgivningsform, der bedst besvarer dine spørgsmål, og også få oplyst en fast indikation af tidsforbruget for rådgivningen.
            </p>
            
            <div className="mt-8">
              <Link 
                to="/kontakt-os" 
                className="inline-flex items-center bg-[#b60f00] text-white px-6 py-3 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95"
              >
                Bestil et gratis uforpligtende møde til økonomisk rådgivning her
              </Link>
            </div>
          </div>
        </div>

        <div className="prose prose-slate prose-lg max-w-none">
          <p>
            Mange vil have stor gavn af vores <Link to="/oekonomi-overblik" className="text-[#b60f00] hover:underline">økonomi overblik</Link>, der kommer hele vejen rundt om økonomien og munder ud i forslag til generelle optimeringsmuligheder inden for de forskellige områder.
          </p>
          <p>
            Du har også mulighed for, at din rådgivning tager udgangspunkt i et fokusområde, eksempelvis pension, omlægning af lån, placering af virksomhedsmidler m.v. I disse tilfælde lægges vægten i rådgivningen naturligvis på fokusområdet, men vi tillader os dog at skæve til de øvrige dele af økonomien, da dette erfaringsmæssigt giver vores kunder størst værdi.
          </p>
          <p>
            Ønsker du for eksempel rådgivning vedr. placering af en opsparing, afhænger investeringsforslaget jo blandt andet af dit likviditetsbehov, din tidshorisont, din skattemæssige situation, din gældsætning, din økonomiske situation, når du går på pension m.v.
          </p>
          <p>
            Spørgsmålet kan altså både besvares isoleret med en placeringsanvisning, normalt fordelt på indlån, obligationer og aktier, men besvares efter vores mening endnu bedre ved også at inddrage andre dele af økonomien, i dette tilfælde bolig-og pensionssituationen.
          </p>
          
          <div className="mt-12 p-6 bg-slate-50 rounded-2xl border border-slate-200">
            <Link to="/priser" className="flex items-center text-[#b60f00] font-bold hover:underline">
              Læs mere om, hvilke papirer vi skal bruge, under fanen Pris <ArrowRight size={18} className="ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OekonomiskRaadgivning;
